import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import axios from "axios";
import connConfig from "@/services/connConfig";

export default class DataServiceTemplate {

  constructor(url, key) {
    this.url = url;
    this.getAllParams = undefined;
    this.dataStore = new CustomStore({
      key: key,
      load: () => {
        return this._getAll();
      },
      byKey: (key) => {
        return this._get(key)
      },
      insert: (values) => {
        return this._create(values)
      },
      update: (key, values) => {
        return this._update(key, values)
      },
      remove: (key) => {
        return this._remove(key)
        //.then(res => { console.log(res.data); })
      }
    });
  this.dataSource = new DataSource({
    store: this.dataStore,
    paginate: false
  });
  }

  setFilter(params) {
    this.getAllParams = { params };
  }

  async _getAll() {
    try {
      let res = await axios.get(this.url, connConfig.connData(this.getAllParams));
      //console.log(res.data);
      return {
        isOk: true,
        data: res.data
      };
    } catch (e) {
      let res = e.response.data;
      if(e.response.status==401){
        location.reload();
      }
      e.isOk = false;
      e.message = res.message || "Error: Server comm error";
      e.message_es = res.message_es || "Error: ha ocurrido un error de comunicación";
      e.data = [];
      throw e
    }
  }

  async _get(key) {
    try {
      let res = await axios.get(`${this.url}/${key}`, connConfig.connData());
      return {data: res.data};
    } catch (e) {
      let res = e.response.data;
      if(e.response.status==401){
        location.reload();
      }
      e.message = res.message || "Error: Server comm error";
      e.message_es = res.message_es || "Error: ha ocurrido un error de comunicación";
      e.data = {};
      throw e
    }
  }

  async _create(values) {
    try {
      let res = await axios.post(this.url, values, connConfig.connData());
      return {
        isOk: true,
        data: res.data
      };
    } catch (e) {
      let res = e.response.data;
      if(e.response.status==401){
        location.reload();
      }
      e.isOk = false;
      e.message = res.message || "Creation failed by an unexpected error";
      e.message_es = res.message_es || "Error: ha ocurrido un error desconocido al crear";
      e.data = res;
      throw e
    }
  }

  async _update(key, values) {
    /**** data not to send to backend can be filtered here */
    delete values.non_editable_property;

    try {
      let res = await axios.put(`${this.url}/${key}`, values, connConfig.connData());
      return res.data;
    } catch (e) {
      let res = e.response.data;
      if(e.response.status==401){
        location.reload();
      }
      e.message = res.message || "Edition failed by an unexpected error";
      e.message_es = res.message_es || "Error: ha ocurrido un error desconocido al guardar cambios";
      e.data = res;
      throw e
    }
  }

  async _remove(key) {
    try {
      let res = await axios.delete(`${this.url}/${key}`, connConfig.connData());
      return res.data;
    } catch (e) {
      let res = e.response.data;
      if(e.response.status==401){
        location.reload();
      }
      e.message = res.message || "Deletion failed by an unexpected error";
      e.message_es = res.message_es || "Error: ha ocurrido un error desconocido al eliminar el registro";
      e.data = res;
      throw e
    }
  }
}